// @core/api/endpoints/userprofile/list_avatars.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAvatarsResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List avatars for profile
 * Returns all avatars associated with a profile, including both active and inactive ones. Only the profile owner can list their avatars.
 */
export async function ListAvatars(
  profile_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAvatarsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/avatars`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.get<ListAvatarsResponse>(requestPath, { ...requestOptions, params });
}
